import "./style.scss";
import $ from "jquery";

$.migrateMute = true;

$(document).ready(function () {
    $('.testimonial-slider__slider').slick({
        infinite: true,
        slidesToShow: 1,
        fade: false,
        dots: true,
        arrows: true,
        nextArrow: '<div class="ow_slick_arrow ah_front_next"><svg width="18" height="38" viewBox="0 0 18 38" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.21289 37.6538L16.8549 19.144L1.21289 0.634277" stroke="black"/> </svg></div>',
        prevArrow: '<div class="ow_slick_arrow ah_front_prev"><svg width="17" height="38" viewBox="0 0 17 38" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.4136 0.634277L0.771518 19.144L16.4136 37.6538" stroke="black"/> </svg></div>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                }
            }
        ]
    });
});